(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pricing-logo-upload"] && !Shopify.designMode) return;
  try {
    
  const PT=[{min:1,max:99,price:42.35},{min:100,max:499,price:41.35},{min:500,max:999,price:39.20},{min:1000,max:4999,price:37.20},{min:5000,max:9999,price:36},{min:10000,max:19999,price:35.29},{min:20000,max:9999999,price:34.60}];
  const BP=42.35;
  function gp(q){return PT.find(x=>q>=x.min&&q<=x.max)||PT[PT.length-1];}
  function upd(){const q=parseInt(document.getElementById('qty').value)||1;const x=gp(q);document.getElementById('unitprice').textContent='₹'+x.price;document.getElementById('totalqty').textContent=q.toLocaleString()+' pcs';const t=x.price*q;document.getElementById('totalamount').textContent='₹'+t.toLocaleString('en-IN');const s=(BP-x.price)*q;document.getElementById('yousave').textContent='₹'+s.toLocaleString('en-IN');}
  document.addEventListener('DOMContentLoaded',function(){
    const dd=document.getElementById('dragdrop');
      const fi=document.getElementById('fileinput');
        const q=document.getElementById('qty');
          const mn=document.getElementById('minus');
            const pl=document.getElementById('plus');
              const cb=document.getElementById('cartbtn');
                const prv=document.getElementById('preview');
                  const rb=document.getElementById('removebtn');
                    let lf=null;
                      if(dd)dd.addEventListener('click',()=>fi.click());
                        if(fi)fi.addEventListener('change',(e)=>{if(e.target.files[0]){const f=e.target.files[0];if(f.size>5*1024*1024){alert('File too large');}else if(f.type!='image/png'){alert('PNG only');}else{const r=new FileReader();r.onload=(x)=>{lf=f;document.getElementById('previewimg').src=x.target.result;document.getElementById('filename').textContent=f.name;prv.style.display='block';dd.style.display='none';};r.readAsDataURL(f);}}});
                          if(q)q.addEventListener('input',()=>{let v=parseInt(q.value)||1;if(v<1)v=1;q.value=v;upd();});
                            if(mn)mn.addEventListener('click',()=>{let v=parseInt(q.value)||1;if(v>1){q.value=v-1;upd();}});
                              if(pl)pl.addEventListener('click',()=>{q.value=parseInt(q.value)+1;upd();});
                                if(rb)rb.addEventListener('click',()=>{fi.value='';lf=null;prv.style.display='none';dd.style.display='block';});
                                  if(cb)cb.addEventListener('click',()=>{if(!lf){alert('Please upload logo first');return;}const q=parseInt(document.getElementById('qty').value);const x=gp(q);const t=x.price*q;alert('✓ Added to cart!\n\nQty: '+q+' pcs\nUnit: ₹'+x.price+'\nLogo: '+(lf.name)+'\nTotal: ₹'+t.toLocaleString('en-IN'));});
                                    upd();
                                    });
                                    
  } catch(e) { console.error(e); }
})();
})();
